import {ICallAndSetData} from "@/services/api-service/interface";
import {getSetApiData} from "@/services/api-service/get-set-api-data";
import {EHttpMethod} from "@/services/api-service/enums";
const UPDATE_PRODUCT_ITEM_ACTION_MACHINE_URL = '/v1/calculation-service/calculations/update-action-machine';
const UPDATE_PRODUCT_ITEM_ACTION_Employee_URL = '/v1/erp-service/update-product-item-action-employee';
const CHANGE_WORK_FLOW = '/v1/erp-service/product-item-value/change-work-flow';

const ADD_OUT_SOURCE_ACTION = '/v1/erp-service/product-item-value/add-out-source-action';
const REMOVE_OUTSOURCE_ACTION = '/v1/erp-service/product-item-value/remove-outsource-action';

const UPDATE_PRODUCT_ITEM_ACTION_DATA_URL = '/v1/erp-service/quote/update-product-item-draft-work-flow-data';
const UPDATE_SELECTED_WORK_FLOW_URL = '/v1/calculation-service/calculations/update-work-flow';
const UPDATE_PRODUCT_ITEM_VALUE_OUTSOURCE = '/v1/erp-service/quote/update-product-item-value-out-source';
const UPDATED_PRODUCT_ITEM_VALUE_OUTSOURCE_SUPPLIER_COST = '/v1/erp-service/quote/update-product-item-value-out-source-supplier-cost';

const UPDATED_BOARD_MISSION_ACTION_OUTPUT_URL = '/v1/erp-service/board-missions/update-board-mission-action-output';

const ADD_ACTION_TO_WORK_FLOW = '/v1/erp-service/product-item-value/add-action-to-work-flow';
const DELETE_ACTION_TO_WORK_FLOW = '/v1/erp-service/product-item-value/delete-action-from-work-flow';
const UPDATE_ACTIONS_ORDER_IN_WORK_FLOW = '/v1/erp-service/product-item-value/update-actions-order-in-work-flow';
const UPDATE_PROFIT_FOR_ALL_ACTIONS_URL = '/v1/erp-service/quote/update-profit-for-all-actions';
const EXPORT_PRODUCT_ITEM_VALUE_TO_JSON_URL = '/v1/erp-service/productItemValueDrafts/export-product-item-value-to-json/:signalRConnectionId';
const CALCULATE_PRODUCT_VARIATIONS_URL = '/v1/erp-service/product-item-value/calculate-product-variations';
const GET_PRODUCT_VARIATIONS_SUMMARY_URL = '/v1/erp-service/product-item-value/get-product-variations-summary';
const GET_CALCULATION_EXCEPTION_REPORT_MESSAGE_URL = '/v1/erp-service/productItemValueDrafts/get-calculation-exception-report-message/:signalRConnectionId';
const GET_JDF_XML_URL = '/v1/erp-service/product-item-value/get-jdf-xml-url';
const updateProductItemDraftActionMachine: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATE_PRODUCT_ITEM_ACTION_MACHINE_URL, setState , data);
}
const changeWorkFlw: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, CHANGE_WORK_FLOW, setState , data);
}
const addOutSourceActionApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, ADD_OUT_SOURCE_ACTION, setState , data);
}

const removeOutSourceActionApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.DELETE, REMOVE_OUTSOURCE_ACTION, setState , data);
}

const updateProductItemDraftActionData: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATE_PRODUCT_ITEM_ACTION_DATA_URL, setState , data);
}
const updateSelectedWorkFlowApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATE_SELECTED_WORK_FLOW_URL, setState , data);
}
const updateProductItemValueOutsource: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATE_PRODUCT_ITEM_VALUE_OUTSOURCE, setState , data);
}
const updateProductItemValueOutsourceSupplierCost: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATED_PRODUCT_ITEM_VALUE_OUTSOURCE_SUPPLIER_COST, setState , data);
}

const updateActionEmployeeApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATE_PRODUCT_ITEM_ACTION_Employee_URL, setState , data);
}

const updateBoardMissionActionOutputApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.POST, UPDATED_BOARD_MISSION_ACTION_OUTPUT_URL, setState , data);
}

const addActionToWorkFlowApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.PUT, ADD_ACTION_TO_WORK_FLOW, setState , data);
}
const deleteActionToWorkFlowApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.PUT, DELETE_ACTION_TO_WORK_FLOW, setState , data);
}
const updateActionsOrderInWorkFlowApi: ICallAndSetData = async (callApi, setState, data:{}) => {
    return await getSetApiData(callApi, EHttpMethod.PUT, UPDATE_ACTIONS_ORDER_IN_WORK_FLOW, setState , data);
}
const updateProfitForAllActionsApi: ICallAndSetData = async (callApi, callBack, data: { signalRConnectionId: string; profit: number }) => {
    return await getSetApiData(callApi, EHttpMethod.PUT, UPDATE_PROFIT_FOR_ALL_ACTIONS_URL, callBack, data);
}

const exportProductItemValueToJsonApi: ICallAndSetData = async (callApi, setState, data: any = {}) => {
    const signalRConnectionId = data?.signalRConnectionId;
    if (!signalRConnectionId) {
        const response = { success: false, data: null };
        setState(response);
        return response;
    }

    const queryParams = { ...data };
    delete queryParams.signalRConnectionId;
    const url = EXPORT_PRODUCT_ITEM_VALUE_TO_JSON_URL.replace(
        ":signalRConnectionId",
        signalRConnectionId
    );

    return await getSetApiData(callApi, EHttpMethod.GET, url, setState, queryParams);
}

const calculateProductVariationsApi: ICallAndSetData = async (
    callApi,
    setState,
    data: { productId: string; productName?: string }
) => {
    return await getSetApiData(
        callApi,
        EHttpMethod.POST,
        CALCULATE_PRODUCT_VARIATIONS_URL,
        setState,
        data
    );
}

const getProductVariationsSummaryApi: ICallAndSetData = async (
    callApi,
    setState,
    data: { productId: string; productName?: string }
) => {
    return await getSetApiData(
        callApi,
        EHttpMethod.POST,
        GET_PRODUCT_VARIATIONS_SUMMARY_URL,
        setState,
        data
    );
}

const getCalculationExceptionReportMessageApi: ICallAndSetData = async (
    callApi,
    setState,
    data: { signalRConnectionId: string }
) => {
    const signalRConnectionId = data?.signalRConnectionId;
    if (!signalRConnectionId) {
        const response = { success: false, data: null };
        setState(response);
        return response;
    }

    const url = GET_CALCULATION_EXCEPTION_REPORT_MESSAGE_URL.replace(
        ":signalRConnectionId",
        signalRConnectionId
    );

    return await getSetApiData(callApi, EHttpMethod.GET, url, setState);
}

const getJdfXmlUrlApi: ICallAndSetData = async (
    callApi,
    setState,
    data: { orderItemId: string; productType?: string }
) => {
    return await getSetApiData(
        callApi,
        EHttpMethod.POST,
        GET_JDF_XML_URL,
        setState,
        data
    );
}

export 
{ 
    changeWorkFlw, 
    updateProductItemDraftActionMachine, 
    updateProductItemDraftActionData, 
    updateSelectedWorkFlowApi, 
    updateProductItemValueOutsource, 
    updateProductItemValueOutsourceSupplierCost,
    updateActionEmployeeApi,
    updateBoardMissionActionOutputApi,
    addOutSourceActionApi,
    removeOutSourceActionApi,
    addActionToWorkFlowApi,
    deleteActionToWorkFlowApi,
    updateActionsOrderInWorkFlowApi,
    updateProfitForAllActionsApi,
    exportProductItemValueToJsonApi,
    calculateProductVariationsApi,
    getProductVariationsSummaryApi,
    getCalculationExceptionReportMessageApi,
    getJdfXmlUrlApi
 };